import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuthApi } from '../hooks/use-auth-api';
import { toEnDigits } from '../lib/utils';

export default function Login() {
  const navigate = useNavigate();
  const { isAuthenticated, isLoading, login, verifyOtp, error, refresh } = useAuthApi();
  const [step, setStep] = useState<'phone' | 'code'>('phone');
  const [phone, setPhone] = useState('');
  const [code, setCode] = useState('');
  const [localError, setLocalError] = useState('');
  const [success, setSuccess] = useState('');

  useEffect(() => {
    if (!isLoading && isAuthenticated) {
      navigate('/');
    }
  }, [isLoading, isAuthenticated, navigate]);

  const handleSendOtp = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!phone.match(/^09[0-9]{9}$/)) {
      setLocalError('شماره موبایل نامعتبر است.');
      return;
    }
    setLocalError('');
    setSuccess('');
    try {
      const data = await login(phone);
      if (data) {
        setStep('code');
        setSuccess(`کد تایید ارسال شد. ${data.otp_code ? '(کد تست: ' + data.otp_code + ')' : ''}`);
      }
    } catch (err: any) {
      setLocalError(err.message || 'خطا در ارسال کد');
    }
  };

  const handleVerify = async (e: React.FormEvent) => {
    e.preventDefault();
    if (code.length < 6) {
      setLocalError('کد ۶ رقمی را کامل وارد کنید.');
      return;
    }
    setLocalError('');
    try {
      await verifyOtp(phone, code);
      // ── بعد از تأیید، هدر را به‌روز کن ──────────────────
      await refresh();
      navigate('/');
    } catch (err: any) {
      setLocalError(err.message || 'کد نامعتبر است.');
    }
  };

  if (isLoading) return <div className="loading">در حال بارگذاری...</div>;

  return (
    <div className="auth-page">
      <div className="auth-container">
        <h2>🔑 ورود به حساب کاربری</h2>
        <p className="subtitle">
          {step === 'phone' ? 'شماره موبایل خود را وارد کنید' : `کد ارسال شده به ${phone} را وارد کنید`}
        </p>
        {(localError || error) && <div className="alert alert-error">{localError || error}</div>}
        {success && <div className="alert alert-success">{success}</div>}

        {step === 'phone' ? (
          <form onSubmit={handleSendOtp} className="form-group">
            <input type="tel" dir="ltr" placeholder="09123456789" value={phone}
              onChange={(e) => setPhone(toEnDigits(e.target.value))} className="otp-input" autoFocus disabled={isLoading} />
            <button type="submit" className="btn btn-primary" disabled={isLoading || !phone.trim()}>
              {isLoading ? '⏳ در حال ارسال...' : 'ارسال کد تایید'}
            </button>
          </form>
        ) : (
          <form onSubmit={handleVerify} className="form-group">
            <p style={{ color: '#666', fontSize: '14px', marginBottom: '10px' }}>کد ۶ رقمی ارسال شده را وارد کنید</p>
            <div className="otp-container">
              {[...Array(6)].map((_, i) => (
                <input key={i} type="text" maxLength={1} value={code[i] || ''}
                  onChange={(e) => {
                    const val = e.target.value.replace(/\D/g, '');
                    if (val) {
                      const newCode = code.split('');
                      newCode[i] = val;
                      setCode(newCode.join(''));
                      if (i < 5) {
                        const next = document.querySelector(`.otp-container input:nth-child(${i + 2})`) as HTMLInputElement;
                        if (next) next.focus();
                      }
                    }
                  }}
                  onKeyDown={(e) => {
                    if (e.key === 'Backspace' && !code[i] && i > 0) {
                      const prev = document.querySelector(`.otp-container input:nth-child(${i})`) as HTMLInputElement;
                      if (prev) prev.focus();
                    }
                  }}
                  disabled={isLoading} />
              ))}
            </div>
            <button type="submit" className="btn btn-primary" disabled={isLoading || code.length !== 6}>
              {isLoading ? '⏳ در حال تایید...' : 'تایید و ورود'}
            </button>
            <div style={{ marginTop: '12px', textAlign: 'center' }}>
              <button type="button" className="btn btn-secondary btn-sm"
                onClick={() => { setStep('phone'); setCode(''); }} disabled={isLoading}>
                تغییر شماره موبایل
              </button>
            </div>
          </form>
        )}
        <div className="auth-link"><a href="/">بازگشت به خانه</a></div>
      </div>
    </div>
  );
}